import { el } from "./dom.js";

export interface LoginScreenCallbacks {
  onSubmit: (password: string) => void;
}

export interface LoginScreen {
  root: HTMLElement;
  setError(text: string | null): void;
  setSubmitting(submitting: boolean): void;
}

export function createLoginScreen(cb: LoginScreenCallbacks): LoginScreen {
  let submitting = false;
  let errorText: string | null = null;

  const passwordInput = el("input", {
    type: "password",
    placeholder: "Admin password",
    autocomplete: "current-password",
    autofocus: true,
  });

  const errorEl = el("div", { class: "error" });

  const submitBtn = el("button", { class: "button", type: "submit" }, "Sign in");

  const form = el(
    "form",
    {
      onsubmit: (e: Event) => {
        e.preventDefault();
        if (submitting) return;
        const pw = (passwordInput as HTMLInputElement).value.trim();
        if (!pw) return;
        cb.onSubmit(pw);
      },
    },
    el(
      "div",
      { class: "field" },
      el("label", { for: "pw" }, "Password"),
      passwordInput,
    ),
    errorEl,
    submitBtn,
  );

  const root = el(
    "div",
    { class: "login-screen" },
    el(
      "div",
      { class: "login-card" },
      el("h1", {}, "Vinyl admin"),
      el(
        "p",
        {},
        "Content authoring for the Vinyl prototype. Use the password set in ADMIN_PASSWORD.",
      ),
      form,
    ),
  );

  return {
    root,
    setError(text) {
      errorText = text;
      errorEl.textContent = text ?? "";
    },
    setSubmitting(s) {
      submitting = s;
      submitBtn.textContent = s ? "Signing in…" : "Sign in";
      (submitBtn as HTMLButtonElement).disabled = s;
    },
  };
}

export function humanizeAdminLoginError(reason: string): string {
  switch (reason) {
    case "wrong_password":
      return "Wrong password.";
    case "missing_password_env":
      return "Admin password not configured on the server. Set ADMIN_PASSWORD in .env and restart.";
    default:
      return reason;
  }
}
